export const QUERY_KEY_TOKEN = 'get idToken';